import React, { createContext, useState, useEffect } from "react";
import * as API from "../utils/api.service";
import Cookies from "js-cookie";

export const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(JSON.parse(localStorage.getItem("permissionCA")) || [  ]);
  const [adminData, setAdminData] = useState(null);

  const fetchPermissions = async (userId) => {
    try {
      const response = await API.getpermissionApi({ id: userId });
      if (response.code == 1) {
        localStorage.setItem("permissionCA", JSON.stringify(response.data))
        setPermissions(response.data);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    const adminDataCookie = Cookies.get("dataCA");
    const parsedAdminData = adminDataCookie ? JSON.parse(adminDataCookie) : null;

    if (parsedAdminData) {
      setAdminData(parsedAdminData); 
      fetchPermissions(parsedAdminData.id);
    } else {
      console.warn("Admin data is not available. Skipping permissions fetch.");
    }
  }, []);

  return (
    <PermissionContext.Provider value={{ permissions }}>
      {children}
    </PermissionContext.Provider>
  );
};
